import 'components/discovery/display-options-toolbar/sort-modes/sort-modes.js'
import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './display-options-toolbar.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'

@customElement('csc-display-options-toolbar')
export class CSCDisplayOptionsToolbar extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: Boolean })
  loading = false

  private renderSkeletonLoading() {
    return html`
      <cse-skeleton variant="secondary" height="48"></cse-skeleton>
    `
  }

  override render() {
    if (this.loading) {
      return this.renderSkeletonLoading()
    }

    return html`
      <div class="csc-display-options-toolbar">
        <cse-text variant="heading-4" class="title">
          <slot></slot>
        </cse-text>
        <div class="options">
          <slot name="actions"></slot>
        </div>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-display-options-toolbar': CSCDisplayOptionsToolbar
  }
}
